import { render, staticRenderFns } from "./FormCheckboxList.vue?vue&type=template&id=4853e3de&"
import script from "./FormCheckboxList.vue?vue&type=script&lang=ts&"
export * from "./FormCheckboxList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports